import { render, staticRenderFns } from "./NuevoDiagnostico.vue?vue&type=template&id=2bab6606&"
import script from "./NuevoDiagnostico.vue?vue&type=script&lang=js&"
export * from "./NuevoDiagnostico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports